import React from 'react'
import ReactDOM from 'react-dom'
import  { useState, useEffect } from "react"
import './App.css'
import Bulb from './Bulb'
import SocialMediaButtons from './SocialMediaButtons'
import {
  ShareButtons,
} from 'react-share';






function App() {

 

//bulb images
const lbon = "./lightbulbon.png"
const lboff = "./lightbulboff.png"


//timer
const [seconds, setSeconds] = useState(0);
const [timerIsActive, setTimerIsActive] = useState(false);

//bulb numbers
const startgameNumber = 3
var numbers = [3,4,5,6,7,8,9,10,11]


//shuffle
// var numbers = [...Array(6).keys()].map(i => i + 1);

var shuffle = (array = []) => {

 
  var randIndex;
  for (let currentIndex = array.length - 1; currentIndex > 0; currentIndex--) {
    randIndex = Math.floor(Math.random() * (currentIndex + 1));
    [array[currentIndex], array[randIndex]] = [
      array[randIndex],
      array[currentIndex]
    ];

    
  }


  return array;

  
}

var [shuffledCards, setShuffledCards] = useState(shuffle(numbers)) 



const [bulbon, setBulbon] = useState(lbon)
const [bulboff, setBulboff] = useState(lboff)


var [bulbstatus1, setBulbstatus1] = useState(lboff)
var [bulbstatus2, setBulbstatus2] = useState(lboff) 
var [bulbstatus3, setBulbstatus3] = useState(lboff) 
var [bulbstatus4, setBulbstatus4] = useState(lboff) 
var [bulbstatus5, setBulbstatus5] = useState(lboff) 
var [bulbstatus6, setBulbstatus6] = useState(lboff) 
var [bulbstatus7, setBulbstatus7] = useState(lboff)
var [bulbstatus8, setBulbstatus8] = useState(lboff) 
var [bulbstatus9, setBulbstatus9] = useState(lboff)  


var [numberArray, setNumberArray] = useState (numbers)
var [numberAnswer, setNumberAnswer] = useState(startgameNumber) 

var [gameCompleteMessage, setGameCompleteMessage] = useState ()
var [startGameMessage, setStartGameMessage] = useState ("Click the bulbs in order")
var [instructionMessage, setInstructionMessage] = useState ("Click the number")



const [showEndGame, setShowEndGame] = useState(false)
const [showGame, setShowGame] = useState(true)



//timer interval
useEffect(() => {
  let interval = null;
  if (timerIsActive) {
    interval = setInterval(() => {
      setSeconds(seconds => seconds + 1);
    }, 100);
  } else if (!timerIsActive && seconds !== 0) {
    clearInterval(interval);
  }
  return () => clearInterval(interval);
}, [timerIsActive, seconds]) 

//reset game
function resetGame () {
 
 }


function wrongAnswer () {

  let soundWrong = new window.Pizzicato.Sound('./lowbeep.wav', function() {
  
    soundWrong.play()
  })


}



function setNumberAnswerUp () {

  if (numberAnswer <11) {
  setNumberAnswer(prevState => prevState + 1)
  setTimerIsActive(true) 

  let soundRight = new window.Pizzicato.Sound('./glocknotec.wav', function() {
  
    soundRight.play()
  })



  }

  else {
    completeGame ()
  }
}


//start new game
function tryAgain () {

  setGameCompleteMessage(gameCompleteMessage => null)
  setShowEndGame(!showEndGame)
 
  // window.location.reload()
  
 
  // alert(numbers)
 

 

  setNumberAnswer (numberAnswer => startgameNumber)

  //setShuffledCards (setShuffledCards => numbers)

  setBulbstatus1 (bulbstatus1 => lboff)
  setBulbstatus2 (bulbstatus2 => lboff)
  setBulbstatus3 (bulbstatus3 => lboff)
  setBulbstatus4 (bulbstatus4 => lboff)
  setBulbstatus5 (bulbstatus5 => lboff)
  setBulbstatus6 (bulbstatus6 => lboff)
  setBulbstatus7 (bulbstatus7 => lboff)
  setBulbstatus8 (bulbstatus8 => lboff)
  setBulbstatus9 (bulbstatus9 => lboff)

  setNumberArray(numberArray => shuffle(numbers))

  setSeconds(seconds =>0)
  setShowGame(!showGame)
  
}




function completeGame () {

  let soundComplete = new window.Pizzicato.Sound('./hi-g-c-glock.wav', function() {
  
    soundComplete.play()
  })

  setTimerIsActive(false);
  setGameCompleteMessage(gameCompleteMessage => "Well done! ")
  setInstructionMessage(instructionMessage => null)
  setNumberAnswer(numberAnswer => null)

  setShowEndGame(!showEndGame)
  setShowGame(!showGame)

}



function handleClick1 () {

  if (numberArray[0] == numberAnswer ) {


    setBulbstatus1(bulbstatus1 => lbon)
    
    
    setNumberAnswerUp ()
    
  
  }

    else {
      wrongAnswer()
    }
}

function handleClick2 () {

  if (numberArray[1] == numberAnswer) {

    setBulbstatus2(bulbstatus2 => lbon)
    
    
    setNumberAnswerUp ()}

    else {
      wrongAnswer()
    }

}

function handleClick3 () {

  if (numberArray[2] == numberAnswer) {

  setBulbstatus3(bulbstatus3 => lbon)
  
  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }

}

function handleClick4 () {

  if (numberArray[3] == numberAnswer ) {

  setBulbstatus4(bulbstatus4 => lbon)

  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }


}

function handleClick5 () {

  if (numberArray[4] == numberAnswer ) {

  setBulbstatus5(bulbstatus5 => lbon)
  
  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }


}


function handleClick6 () {

  if (numberArray[5] == numberAnswer ) {

  setBulbstatus6(bulbstatus6 => lbon)

  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }


}


function handleClick7 () {

  if (numberArray[6] == numberAnswer ) {

  setBulbstatus7(bulbstatus7 => lbon)

  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }


}

function handleClick8 () {

  if (numberArray[7] == numberAnswer ) {

  setBulbstatus8(bulbstatus8 => lbon)

  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }


}

function handleClick9 () {

  if (numberArray[8] == numberAnswer ) {

  setBulbstatus9(bulbstatus9 => lbon)

  
  setNumberAnswerUp ()}
  else {
    wrongAnswer()
  }


}


//Timer display
const Timer = () => {
  
  return (
    <div> {seconds} seconds</div>
       
  )
}

//toggle timer isActive
function toggle() {
  setTimerIsActive(!timerIsActive);
}

//reset timer
function reset() {
  setSeconds(0);
  setTimerIsActive(false);
}




  return (


    <div className="App">


    {showGame &&   

      <div>

      <header className="App-header">
      <h1>{startGameMessage}</h1>
        {/* <h1>Number lightbulbs</h1> */}
      </header>

    
    
    

      <ul>
      <li class="letter" onClick={handleClick1} >
        <Bulb bulbInfo={{number:numberArray[0], imgUrl:bulbstatus1, id:1, lit1:false}} />
      </li>  
        
      <li class="letter" onClick={handleClick2}  > 
        <Bulb bulbInfo={{number:numberArray[1], imgUrl:bulbstatus2, id:2, lit2:false}}/>
      </li>  

      <li class="letter" onClick={handleClick3} > 
        <Bulb bulbInfo={{number:numberArray[2], imgUrl:bulbstatus3, id:3, lit3:false}}/>
      </li>

      <li class="letter" onClick={handleClick4} > 
        <Bulb bulbInfo={{number:numberArray[3], imgUrl:bulbstatus4, id:4, lit4:false}}/>
      </li>

      <li class="letter" onClick={handleClick5} > 
        <Bulb bulbInfo={{number:numberArray[4], imgUrl:bulbstatus5, id:5, lit5:false}}/>
      </li>

      <li class="letter" onClick={handleClick6}> 
        <Bulb bulbInfo={{number:numberArray[5], imgUrl:bulbstatus6, id:6, lit6:false}}/>
      </li>

      <li class="letter" onClick={handleClick7}> 
        <Bulb bulbInfo={{number:numberArray[6], imgUrl:bulbstatus7, id:7, lit7:false}}/>
      </li>

      <li class="letter" onClick={handleClick8}> 
        <Bulb bulbInfo={{number:numberArray[7], imgUrl:bulbstatus8, id:8, lit8:false}}/>
      </li>

      <li class="letter" onClick={handleClick9}> 
        <Bulb bulbInfo={{number:numberArray[8], imgUrl:bulbstatus9, id:9, lit9:false}}/>
      </li>


      </ul>

      <h2 class="timerFont">{(seconds/10).toFixed(1)}</h2>   
      {/* <h1>{gameCompleteMessage}</h1> */}
     
     </div>

    }
  
      
      {showEndGame &&

<div>
<h1><img src="./lightbulbon.png"></img> </h1>  
<h2 >Well done! You did it in {(JSON.stringify(seconds/10))} seconds <button class="tryagain" onClick={tryAgain}>try again</button></h2>
<h3><strong>Tell others how well you did.<br></br>Challenge them to beat you.{"\uD83C\uDFC6"}</strong></h3>
<h3>Share your results
<SocialMediaButtons 
url="https://www.wordpip.com/lightbulb-game-3-11"
text="I completed it in" 
seconds={seconds/10} 
text2="seconds. Can you do better?"
via="wordpip"
imgURL="https://www.wordpip.com/img/games/BulbShareImage.PNG"
/>
</h3>

  

</div> }

      



     
     
        
    </div>



  );


  

 
}

export default App;
